import React, { useState, useEffect  } from "react";
import { IconButton, ListItemButton, ListItemText, Collapse } from "@mui/material";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Tooltip } from "@mui/material";

const CategoryList = ({
  categories,
  primaryColor,
  textColor,
  allProducts,
  isMobile,
  selectedCategory,
  handleCategoryClick,
  currentCategories,
  handleClickAll
}) => {
  const [expandedCategoryIds, setExpandedCategoryIds] = useState({});
  const [expand,setExpand] = useState(false)

    // Expand the parent categories automatically
    useEffect(() => {
      if (selectedCategory && categories?.data && !expand) {
        const findCategoryPath = (items, targetId, path = []) => {
          for (const item of items) {
            const newPath = [...path, item];
            if (item.category_id === targetId) {
              return newPath;
            }
            if (item.children && item.children.length > 0) {
              const childPath = findCategoryPath(item.children, targetId, newPath);
              if (childPath) return childPath;
            }
          }
          return null;
        };
  
        const path = findCategoryPath(categories.data, selectedCategory);
        if (path) {
          const expandedIds = {};
          // Expand all except the last one (which is the selected item itself)
          path.slice(0, -1).forEach((cat) => {
            expandedIds[cat.category_id] = true;
          });
          if (Object.keys(expandedIds).length > 0) {
            setExpandedCategoryIds(expandedIds);
          }
        }
      }
    }, [selectedCategory, categories, !expand]);

  // Toggle expand/collapse for multiple
  const handleExpandClick = (categoryId) => {
    setExpand(true)
    setExpandedCategoryIds((prev) => ({
      ...prev,
      [categoryId]: !prev[categoryId],
    }));
  };

  // Convert hex to rgba
  const hexToRGBA = (hex, alpha) => {
    if (!hex) return "#FFF3F3";
    return `rgba(${parseInt(hex.substring(1, 3), 16)}, ${parseInt(
      hex.substring(3, 5), 16)}, ${parseInt(hex.substring(5, 7), 16)}, ${alpha})`;
  };

  const handleItemClick = (item, event) => {
    event.stopPropagation(); // prevent event bubbling
    if (item.children && item.children.length > 0) {
      handleExpandClick(item.category_id);
    }
    handleCategoryClick(item, item.category_id, item.category_name);
  };
  
  
  

  // Recursive Category Renderer
  const renderCategory = (item, level = 0) => (
    <React.Fragment key={item.category_id}>
      <ListItemButton
        selected={selectedCategory === item.category_id}
        sx={{
          pl: 2 + level * 2, // Increase left padding based on level
          backgroundColor: selectedCategory === item.category_id ? hexToRGBA(primaryColor, 0.5) : "transparent",
          color: selectedCategory === item.category_id ? textColor : "black",
          borderLeft: selectedCategory === item.category_id ? `6px solid ${primaryColor}` : "none",
        }}
        onClick={(event) => handleItemClick(item, event)}


      >
        <img
          style={{
            width: isMobile ? "100%" : "15%",
            height: isMobile ? "10vh" : "6vh",
            objectFit: "contain",
          }}
          src={item.category_img_path}
          alt={item.category_name}
          onClick={(event) => handleItemClick(item, event)}

          // onClick={() => handleCategoryClick(item, item.category_id, item.category_name)}
        />
        {!isMobile && (
          <Tooltip title={item.category_name} arrow>

          <ListItemText
          primary={
            item.category_name.length > 18
              ? item.category_name.slice(0, 18) + "..."
              : item.category_name
          }
            onClick={(event) => handleItemClick(item, event)}
            sx={{
              fontWeight: 500,
              fontSize: "13px",
              lineHeight: "20px",
              padding: "0.8em",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          />
          </Tooltip>

        )}
        {/* Expand Icon */}
        {item.children && item.children.length > 0 && (
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              handleExpandClick(item.category_id);
            }}
            sx={{ padding: "5px" }}
          >
            {expandedCategoryIds[item.category_id] ? (
              <ExpandMoreIcon sx={{ fontSize: "16px" }} />
            ) : (
              <ArrowForwardIosIcon sx={{ fontSize: "16px" }} />
            )}
          </IconButton>
        )}
      </ListItemButton>

      {/* Recursively render children if expanded */}
      {item.children && item.children.length > 0 && (
        <Collapse in={expandedCategoryIds[item.category_id]} timeout="auto" unmountOnExit>
          {item.children.map((child) => renderCategory(child, level + 1))}
        </Collapse>
      )}
    </React.Fragment>
  );

  return (
    <>
      {/* All Products Button */}
      {categories?.data?.length > 0 && (
        <ListItemButton
          selected={selectedCategory === "all"}
          onClick={() => handleClickAll()}
          sx={{
            backgroundColor: selectedCategory === "all" ? hexToRGBA(primaryColor, 0.5) : "transparent",
            color: selectedCategory === "all" ? textColor : "black",
            borderLeft: selectedCategory === "all" ? `6px solid ${primaryColor}` : "none",
          }}
        >
          <img
            style={{
              width: isMobile ? "100%" : "15%",
              height: isMobile ? "10vh" : "6vh",
              objectFit: "contain",
            }}
            src={allProducts}
            alt="All Products"
          />
          {!isMobile && (
            <ListItemText
              primary="All Products"
              sx={{
                fontWeight: 500,
                fontSize: "13px",
                lineHeight: "20px",
                padding: "0.8em",
              }}
            />
          )}
        </ListItemButton>
      )}

      {/* Render All Current Categories */}
      {currentCategories?.length > 0 &&
        currentCategories.map((item) => renderCategory(item))}
    </>
  );
};

export default CategoryList;
